export const getMiddlePosition = (positionA, positionB) => ({
    lat: (positionA.lat + positionB.lat) / 2,
    lng: (positionA.lng + positionB.lng) / 2,
});
